import { RootState } from '@app/store/types';

export const getDocuments = (state: RootState) => state.documents;

export const getDocumentExtension = (state: RootState) => getDocuments(state).documentExtension;
export const getDocumentUploadStatus = (state: RootState) =>
  getDocuments(state).documentUploadStatus;
export const isRejecting = (state: RootState) => getDocuments(state).isRejecting;
